import React, { useState } from 'react';
import { Tooltip } from 'react-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const Popup = ({ title, content, onClose }) => {
    const [isChecked, setIsChecked] = useState(false);
    const [isCheckedSave, setIsCheckedSave] = useState(false);

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };

    const handleCheckboxSave = () => {
        setIsCheckedSave(!isCheckedSave);
        localStorage.setItem("popRem", !isCheckedSave);
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg relative flex flex-col items-center">
                <h2 className="text-2xl font-bold mb-4 text-center w-full">{title}</h2>
                <div className="mb-4 text-left w-full">
                    <ul className="max-w-md space-y-1 text-black-500 list-inside dark:text-black-500">
                        <li className="flex items-top">
                            <svg className="mt-1 w-3.5 h-3.5 me-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                 aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                                 viewBox="0 0 20 20">
                                <path
                                    d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                            </svg>
                            The video may take a long time to download depending on the chosen format.
                        </li>
                        <li className="flex items-top">
                            <svg className="mt-1 w-3.5 h-3.5 me-2 text-green-500 dark:text-green-400 flex-shrink-0"
                                 aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                                 viewBox="0 0 20 20">
                                <path
                                    d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                            </svg>
                            <span>
                                  {content}
                                <a className="underline text-red-600"
                                   href='https://www.youtube.com/howyoutubeworks/policies/copyright/' target='_blank'
                                   rel='noreferrer'> copyright may be illegal.</a>
                            </span>

                        </li>
                    </ul>

                </div>
                <div className="mb-4 flex items-center w-full">
                    <input
                        type="checkbox"
                        id="confirm"
                        className="hidden"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                    />
                    <label htmlFor="confirm" className="flex items-center cursor-pointer w-full">
                        <span
                            className={`w-5 h-5 inline-block mr-2 border-2 rounded ${isChecked ? 'bg-red-600 border-red-600' : 'bg-white border-gray-400'}`}>
                            {isChecked && (
                                <svg className="w-4 h-4 text-white mx-auto" xmlns="http://www.w3.org/2000/svg"
                                     viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                                     strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="20 6 9 17 4 12"/>
                                </svg>
                            )}
                        </span>
                        <span>I have read and understood the rules</span>
                        {/*<FontAwesomeIcon*/}
                        {/*    icon={faInfoCircle}*/}
                        {/*    className="w-5 h-5 text-gray-500 ml-2 cursor-pointer"*/}
                        {/*    data-tooltip-id="tooltip-confirm"*/}
                        {/*    data-tooltip-content="Check this box to agree to the rules"*/}
                        {/*/>*/}
                    </label>
                    <Tooltip id="tooltip-confirm" clickable />
                </div>
                <div className="mb-4 flex items-center w-full">
                    <input
                        type="checkbox"
                        id="save"
                        className="hidden"
                        checked={isCheckedSave}
                        onChange={handleCheckboxSave}
                    />
                    <label htmlFor="save" className="flex items-center cursor-pointer w-full">
                        <span
                            className={`w-5 h-5 inline-block mr-2 border-2 rounded ${isCheckedSave ? 'bg-red-600 border-red-600' : 'bg-white border-gray-400'}`}>
                            {isCheckedSave && (
                                <svg className="w-4 h-4 text-white mx-auto" xmlns="http://www.w3.org/2000/svg"
                                     viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                                     strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="20 6 9 17 4 12"/>
                                </svg>
                            )}
                        </span>
                        <span>Remember</span>
                        <FontAwesomeIcon
                            icon={faInfoCircle}
                            className="w-5 h-5 text-gray-500 ml-2 cursor-pointer"
                            data-tooltip-id="tooltip-save"
                            data-tooltip-content="click if you no longer want to see this message"
                        />
                    </label>
                    <Tooltip id="tooltip-save" clickable />
                </div>
                <button
                    className={`w-full px-4 py-2 text-white rounded-lg ${isChecked ? 'bg-red-600 hover:bg-red-700' : 'bg-gray-400 cursor-not-allowed'}`}
                    onClick={onClose}
                    disabled={!isChecked}
                >
                    Close
                </button>
            </div>
        </div>
    );
};

export default Popup;
